import { fetchMethod } from "../../FetchMethod";
import gql from "graphql-tag";
export const contacts = id =>
  `query {
    allContacts(where: { id: ${id}}) {
      totalCount
      Contacts {
        id
        linkedinid
        campaignid
        profileimage
        image
        profileurl
              invitationsent
    currentstatus
        email
        industry
        dateofbirth
        organization
        name
        Campaigns: campaignIbfk4rel {
          Campaigns {
            name
            customerid
            status
            active
            Customers: customerIbfk1rel {
              Customers {
                company
              }
            }
          }
        }
        designation
        joiningdate
        lasteducationinstitute
        twitter
        skype
        phonenumber
        phonetype
        numberoffollowers
        connectedon
        createdon
        headline 
        location
        campaignstatus
        contactstatus
        updatedon
        active
        state
        country

      }
    }
}`;

export const getContactData = async id =>
  await fetchMethod(contacts(id))
    .then(response => response.json().then(data => data))
    .catch(e => console.log("Errror", e));

export const updateStatus = gql`
  mutation($where: JSON, $data: JSON) {
    ContactsUpsertWithWhere(where: $where, data: $data) {
      id
    }
  }
`;
export const addAction = gql`
  mutation($data: JSON) {
    ContactlogsCreate(data: $data) {
      id
    }
  }
`;



export const CustomerInfo = `query($where:JSON){
  allCampaigns(where:$where){
    Campaigns{
      customerIbfk1rel{
        Customers{
          company
          id
        }
      }
    }
  }
}
`;

export const allcampaigns = gql`
  query($where: JSON) {
    allCampaigns(where: $where) {
      totalCount
      Campaigns {
        id
      }
    }
  }
`;

export const ManagerName = gql`
  query($where: JSON) {
    allCampaigns(where: $where) {
      Campaigns {
        id
        customerid
        name
      }
    }
  }
`;

export const Company = gql`
  query($where: JSON) {
    allCustomers(where: $where) {
      Customers {
        id
        company
      }
    }
  }
`;
export const ManagersName = gql`
  query($where: JSON) {
    allCampaigns(where: $where) {
      Campaigns {
        id
        name
        linkedinid
        customercredentialsIbfk1rel {
          Customerlinkedinprofiles {
            id
            name
          }
        }
      }
    }
  }
`;
export const ProfileName = gql`
  query($where: JSON) {
    allCustomers(where: $where) {
      Customers {
        id
        company
        Customerlinkedinprofilesfk {
          Customerlinkedinprofiles {
            name
            id
            Campaignsfk {
              Campaigns {
                id
              }
            }
          }
        }
      }
    }
  }
`;
